export default __webpack_public_path__ + "static/media/index.854b5f53.svg";